import type { CSSProperties, JSX } from 'react';
import { CheckCircleFilled } from '@ant-design/icons';

import { Tag } from '../ds';
import type { MyPlanCardDto } from '../../lib/api/openingTasks';
import { fmtWindow, overdueByStage, phaseColor } from './plan-model';

/**
 * Список «Этапы» (как `StageList` в CRM): отметка (пройден ✓ / идёт / впереди), название · отдел, окно дат (≈ у
 * прогноза) и «задачи x/y». Нажатие открывает задачи этапа во вкладке «Задачи».
 */
export function PlanStageList({
  card,
  onGoStage,
}: {
  card: Pick<MyPlanCardDto, 'stages' | 'tasks'>;
  onGoStage: (stageCode: string) => void;
}): JSX.Element {
  const overdue = overdueByStage(card.tasks);
  return (
    <section className="fk-op-card" aria-label="Этапы открытия">
      <div className="fk-op-h">Этапы</div>
      <div>
        {card.stages.map((s) => {
          const late = overdue.get(s.code) ?? 0;
          return (
            <button
              key={s.code}
              type="button"
              className="fk-op-stage"
              data-state={s.state}
              title="Открыть задачи этапа"
              style={{ '--ph': phaseColor(s.phaseCode) } as CSSProperties}
              onClick={() => onGoStage(s.code)}
            >
              <span className="fk-op-mark" aria-hidden="true">
                {s.state === 'done' ? <CheckCircleFilled /> : <i data-current={s.state === 'current'} />}
              </span>
              <span className="fk-op-stage-name">
                <b>{s.label}</b>
                {s.deptLabel ? <span> · {s.deptLabel}</span> : null}
                {s.state === 'done' ? <span> · пройден</span> : s.state === 'current' ? <span> · сейчас</span> : null}
              </span>
              <span className="fk-op-stage-meta">
                <span className="fk-op-win">{fmtWindow(s.start, s.end, s.estimated && s.state !== 'done')}</span>
                {s.tasksTotal > 0 ? (
                  <span>
                    задачи {s.tasksDone}/{s.tasksTotal}
                  </span>
                ) : null}
                {late > 0 ? <Tag color="red">{`просрочено ${late}`}</Tag> : null}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
